import { safeLocalStorage } from '@toss/storage';

import { Logger, LoggerRole, logInTable } from '../../logger';

import type { ExternalEventTrackingClient } from './types';

const CONSOLE_DEBUG_KEY = 'ZETTA_DEBUG';
type ZettaLoggerOptions = {
  role?: LoggerRole;
};

export class ZettaLogger implements Logger {
  public name = 'ZettaLogger';
  public role: LoggerRole;
  private _zettaClient: ExternalEventTrackingClient;

  constructor(
    zettaClient: ExternalEventTrackingClient,
    options?: ZettaLoggerOptions,
  ) {
    this._zettaClient = zettaClient;
    this.role = options?.role ?? 'tracking';
  }

  private _debug(message: string, params: Record<string, unknown> = {}) {
    logInTable(message, {
      name: this.name,
      optionalParams: params,
    });
  }

  log: Logger['log'] = (message, params) => {
    this.track(message, params);
  };

  /**
   * `beacon` 은 PostHog 의 배칭 큐를 거치지 않고 sendBeacon 으로 즉시 보낸다.
   * pagehide 에서는 SDK 자신의 unload 핸들러가 우리보다 먼저 큐를 비울 수 있어,
   * 이탈 직전 이벤트를 큐에 넣으면 그대로 사라진다.
   */
  track: NonNullable<Logger['track']> = (message, params, options) => {
    if (safeLocalStorage.get(CONSOLE_DEBUG_KEY) === 'true') {
      this._debug(message, params);
    }

    if (options?.beacon) {
      this._zettaClient.track(message, params, {
        transport: 'sendBeacon',
        send_instantly: true,
      });
      return;
    }
    this._zettaClient.track(message, params);
  };

  debug: Logger['debug'] = (message, params) => {
    this.log(message, params);
  };

  identify(userId: string): void {
    this._zettaClient.identify(userId);
  }

  setUserProperties(userProperties: Record<string, unknown>): void {
    this._zettaClient.setUserProperties(userProperties);
  }
}
